export class EnvService {
    apiUrl: string;
    adminUrl: string;
    chatUrl: string;
}
